import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AvailabilityCalendar from '../profile_page/AvailabilityCalendar';
import '../../styles/components/dashboard/DashboardAvailability.css';

const DashboardAvailability = () => {
  const { userAttributes } = useAuth();
  return (
    <section className="dashboard-availability" aria-labelledby="dashboard-availability-title">
      <h2 id="dashboard-availability-title">Your availability</h2>
      <AvailabilityCalendar photographerId={userAttributes?.sub} />
    </section>
  );
};

export default DashboardAvailability;
